"use client";
import { usePathname } from "next/navigation";
import Link from "next/link";
import "./BreadCrumbs.scss";
import { capitalizeFirstLetter } from "@/utils/commonfuntions";

// Mapper for custom routes or redirections
const routeMapper = {
  treatments: "/",
  advisors: "/",
  "dietitian-experts": "/fitness/dietitian-expertlist",
  "yoga-experts": "/fitness/yoga-expertlist",
  "physiotherapist-experts": "/fitness/physiotherapist-experts",
};

export default function BreadCrumbs() {
  const pathname = usePathname();
  const segments = pathname.split("/").filter((item) => item !== "");

  return (
    <div className="breadCrumbsWrapper">
      {segments.length > 0 && (
        <ul className="breadcrumbs">
          <Link href="/" className="inactiveLink">
            Home
          </Link>
          <li>
            <p className="m-auto">/</p>
          </li>
          {segments.map((name, index) => {
            // Check if the segment has a mapped route
            const routeTo =
              routeMapper[name] || `/${segments.slice(0, index + 1).join("/")}`;

            const isLast = index === segments.length - 1;

            return (
              <div key={index}>
                <li>
                  {isLast ? (
                    <p className="activeLink m-auto">
                      {capitalizeFirstLetter(name)}
                    </p>
                  ) : (
                    <p className="m-auto">
                      <Link className="inactiveLink" href={routeTo}>
                        {capitalizeFirstLetter(name)}
                      </Link>
                      <span> /</span>
                    </p>
                  )}
                </li>
              </div>
            );
          })}
        </ul>
      )}
    </div>
  );
}
